import { render, staticRenderFns } from "./GoodsModel.vue?vue&type=template&id=10e7b7f8&scoped=true"
import script from "./GoodsModel.vue?vue&type=script&lang=js"
export * from "./GoodsModel.vue?vue&type=script&lang=js"
import style0 from "./GoodsModel.vue?vue&type=style&index=0&id=10e7b7f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e7b7f8",
  null
  
)

export default component.exports